<template>
  <v-flex>
    <scenario-form
      v-model="showForm"
      v-if="showForm"
      :dashboard-scenario-id="selectedScenario"
      @save="onFormSave"
    />
    <section v-show="!showForm">
      <page-toolbar style="display:none">
        <kendo-button
          icon="add"
          title="Add new"
          style="display:none;"
          @click="addRecord"
          v-if="!isReadOnly"
        >
        </kendo-button>
        <kendo-button
          type="button"
          title="Export to Excel"
          style="display:none;"
          @click="exportToExcel"
        >
          <i class="k-icon k-i-excel"></i>
        </kendo-button>
      </page-toolbar>
      <div ref="scenarioGrid"></div>
    </section>
  </v-flex>
</template>

<script>
import eventBus from '@/helpers/event-bus'
import $ from '@/helpers/jquery-bridge'
import {mapGetters} from 'vuex'
import PageToolbar from '@/components/PageToolbar'
import ScenarioForm from './Form'
import security from '@/mixins/security'

export default {
  name: 'DashboardScenario',
  mixins: [security],
  data() {
    return {
      showForm: false,
    }
  },
  mounted() {
    let vm = this
    eventBus.$on('refreshDashboards', () => {
      this.refreshGrid()
    })

    let grid = $(this.$refs.scenarioGrid)
      .kendoGrid({
        dataSource: new kendo.data.DataSource({
          type: 'aspnetmvc-ajax',
          serverPaging: true,
          serverFiltering: true,
          serverSorting: true,
          pageSize: 15,
          transport: {
            read: {
              type: 'GET',
              url: '/api/config/dashboardScenario',
              data: () => ({clientId: this.clientId}),
              dataType: 'json',
            },
            destroy: {
              type: 'DELETE',
              url: '/api/azureStorage/deleteScenario',
            },
          },
          schema: {
            data: 'data',
            errors: 'errors',
            total: 'total',
            model: {
              id: 'dashboardScenarioId',
              fields: {
                dashboardId: {type: 'number'},
                userId: {type: 'number'},
                dashboardDate: {type: 'date'},
                createDate: {type: 'date'},
                status: {type: 'string'},
                scenarioName: {type: 'string'},
                sendToEmail: {type: 'string'},
                scenarioClients: {type: 'string'},
              },
            },
          },
          error: function() {
            grid.one('dataBinding', e => {
              e.preventDefault()
            })
          },
        }),
        editable: !vm.isReadOnly && 'inline',
        filterable: true,
        sortable: true,
        pageable: true,
        edit: this.onEdit,
        columns: [
          {
            command: [{name: 'edit'}],
            width: 82,
            attributes: {style: 'text-align: center;'},
            hidden: true,
          },
          {
            title: 'Scenario',
            field: 'scenarioName',
            width: 200,
            attributes: {style: 'text-align: left;'},
          },
          {
            title: 'Status',
            field: 'status',
            width: 160,
            attributes: {style: 'text-align: left;'},
          },
          {
            title: 'User',
            field: 'username',
            width: 160,
            hidden: true,
            attributes: {style: 'text-align: left;'},
          },
          {
            title: 'Dashboard Date',
            field: 'dashboardDate',
            width: 150,
            format: '{0:yyyy-MM-dd}',
          },
          {
            title: 'Creation Date',
            field: 'createDate',
            width: 200,
            format: '{0:yyyy-MM-dd HH:mm:ss}',
          },
          {
            title: 'Dashboards',
            field: 'scenarioDashboards',
            hidden: true,
            attributes: {class: 'truncate-grid-column-text'},
          },
          {
            command: [{name: 'destroy'}],
            width: 82,
            attributes: {style: 'text-align: center;'},
          },
          {},
        ],
        detailInit: vm.detailInit,
        //detailCollapse: () => grid.dataSource.read(),
        //detailExpand: container => container.masterRow.find('.k-grid-delete').hide(),
      })
      .getKendoGrid()
  },
  methods: {
    detailInit(e) {
      const dashboardScenarioId = e.data.dashboardScenarioId

      let subGrid = $('<div/>')
        .appendTo(e.detailCell)
        .kendoGrid({
          navigatable: true,
          //toolbar: !this.isReadOnly ? ['create'] : '',
          editable: false,
          dataSource: {
            type: 'aspnetmvc-ajax',
            serverPaging: true,
            serverFiltering: true,
            serverSorting: true,
            pageSize: 10,
            transport: {
              read: {
                type: 'GET',
                url: '/api/config/dashboardScenario/readDetail',
                data: () => ({dashboardScenarioId: dashboardScenarioId}),
                dataType: 'json',
              },
            },
            schema: {
              data: 'data',
              total: 'total',
              model: {
                id: 'dashboardScenarioDetailId',
                fields: {
                  dashboardId: {type: 'number'},
                  dashboardName: {type: 'string'},
                  clientName: {type: 'string'},
                  hasDashboardGenerated: {type: 'boolean'},
                },
              },
            },
            error: function() {
              subGrid.one('dataBinding', function(er) {
                er.preventDefault()
              })
            },
          },
          filterable: true,
          sortable: true,
          pageable: true,
          columns: [
            {
              field: 'clientName',
              title: 'Client',
              width: '200px',
            },
            {
              field: 'dashboardName',
              title: 'Dashboard Name',
              width: '200px',
            },

            {},
          ],
          dataBound: function(e) {
            var rows = e.sender.tbody.children()
            for (var j = 0; j < rows.length; j++) {
              var row = $(rows[j])
              var dataItem = e.sender.dataItem(row)
              if (dataItem.hasDashboardGenerated === false) {
                row.addClass('row-red')
              }
            }
          },
        })
    },
    refreshGrid() {
      let grid = $(this.$refs.scenarioGrid).getKendoGrid()
      grid.dataSource.read()
    },
    exportToExcel() {
      const url = `/api/config/division/exportToExcel?clientId=${this.clientId}&t=${
        this.tokenString
      }`
      location.href = url
    },
    addRecord() {
      this.selectedScenario = -1
      this.showForm = true
    },
    onFormSave() {
      let grid = $(this.$refs.scenarioGrid).getKendoGrid()
      grid.dataSource.read()
    },
    onEdit(e) {
      this.selectedScenario = e.model.dashboardScenarioId
      this.showForm = true
      e.sender.cancelChanges()
    },
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    ...mapGetters({tokenString: 'authentication/tokenString'}),
  },
  components: {
    PageToolbar,
    ScenarioForm,
  },
}
</script>
<style>
.row-red {
  background-color: red !important;
}
</style>
